export const homeHelp = {
	title: "Support",
	text: "Afin d’améliorer notre service d’assistance, nous avons mis en place HELP2LS, une solution de helpdesk vous permettant de créer et de suivre vos demandes d’assistance.",
	'group-fb': "Vous pouvez également rejoindre notre {0}. L'aide y est gratuite et les autres utilisateurs d'Osteo2ls pourront vous apporter leur aide.",
	'link-title': "Groupe d'entraide pour Osteo2ls",
	'link-label': "groupe d'entraide sur Facebook",
	'no-support-account': {
		text: "Vous n’avez pas encore de compte Support. Pour pouvoir accéder à toutes les fonctionnalités et gérer vos tickets facilement, créez dès maintenant votre compte HELP2LS en cliquant sur le bouton ci-dessous.",
		"link-label": "créer mon compte HELP2LS",
		"link-title": "Créez votre compte HELP2LS",
		"success": "Compte HELP2LS créé avec succès !",
		"failed": "Erreur lors de la création du compte HELP2LS, veuillez réessayer plus tard.",
		'already-exists':"Un compte HELP2LS existe déjà pour cet utilisateur. Vous pouvez vous connecter ou réinitialiser votre mot de passe si nécessaire."
	},
	'support-account': {
		text: "Votre compte Support est activé. Vous pouvez désormais accéder à HELP2LS pour consulter ou créer vos tickets."
	},
	'go-help2ls': {
		title: "Aller sur le support HELP2LS",
		label: "aller sur HELP2LS"
	},
	'forgot-password-help2ls': {
		title: "Réinitialiser mon mot de passe HELP2LS",
		label: "mot de passe oublié ?"
	}
}
